import styled from "styled-components";
import { theme } from "../../../../../../../common-deprecated/styles/v2/toyota/theme/toyotaTheme";

export const BannerContainer = styled.div`
    width: 100%;
    max-width: 1140px;
    margin: 0 auto 3rem;
    padding-inline: 2rem;
    padding-block-start: 2rem;
`;

export const BannerContent = styled.div<{ open?: boolean }>`
    display: flex;
    flex-direction: column;
    align-items: stretch;
    box-shadow:
        0 0.68px 3.62px 0 rgba(0, 0, 0, 0.02),
        0 1.88px 10.02px 0 rgba(0, 0, 0, 0.03),
        0 4.52px 24.12px 0 rgba(0, 0, 0, 0.05),
        0 15px 80px 0 rgba(0, 0, 0, 0.04);

    @media (width >= 700px) {
        display: grid;
        grid-template-columns: ${({ open }) => (open ? "1fr 2fr" : "1fr")};
    }
`;

export const BannerText = styled.div<{ open?: boolean }>`
    padding-inline: ${theme.space[4]}px;
    padding-block: ${({ open }) => (open ? theme.space[5] : theme.space[2])}px;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: ${theme.space[2]}px;
`;

export const BannerTitle = styled.h2<{ open?: boolean }>`
    margin: 0;
    font-family: ${({ open }) => (open ? theme.fonts.regular : theme.fonts.semiBold)};
    font-size: ${({ open }) => (open ? 2.2 : 2)}rem;
    text-transform: unset !important;
    color: ${theme.colors.primaryBlack};
`;

export const BannerDescription = styled.p`
    min-height: 50px;
    margin: 0;
    font-family: ${theme.fonts.base};
    font-size: 1.6rem;
    color: ${theme.colors.primaryBlack};
`;

export const ShowHideButton = styled.button<{ open?: boolean }>`
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 0.5rem;
    padding: 8px 12px;
    color: ${({ open }) => (open ? theme.colors.primaryBlack : theme.colors.primaryWhite)};
    background-color: ${({ open }) => (open ? theme.colors.grey2 : theme.colors.primaryBlack)};
    transition: all 0.2s ease-in-out;
    cursor: pointer;

    &:hover {
        color: ${theme.colors.primaryWhite};
        background-color: ${theme.colors.grey7};
    }

    &:focus,
    &:focus-visible {
        outline: 2px solid ${theme.colors.hybrid};
        outline-offset: 0.2rem;
    }
`;

export const BannerImageFigure = styled.figure`
    margin: 0;
`;

export const BannerImage = styled.img`
    width: 100%;
    max-width: 100%;
    object-fit: cover;
    height: 100%;
    aspect-ratio: 4/3;
`;
